module.exports = __webpack_public_path__ + "img/chr_ts_15_penlight.12ff3159.png";